import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from '../tooltip/Tooltip';

const OverlayIcon = ({ tooltip, onClick, className }) => {
  return (
    <OverlayTrigger
      overlay={<Tooltip className='gne-tooltip'>{tooltip}</Tooltip>}>
      <i
        onClick={onClick}
        className={`${className}`}
      />
    </OverlayTrigger>
  );
};

export default OverlayIcon;
